export const getRecommendationsModalSettings: () => Record<
  string,
  any
> | null = () => {
  const settingsStr = localStorage.getItem('recommendations-modal-settings');
  const parsedSettings = settingsStr != null ? JSON.parse(settingsStr) : null;

  return parsedSettings;
};
